import styled from '@emotion/styled'

export const TextSection = styled.section`
    padding: 18px 32px;
    max-height: 60vh;
    overflow: auto;
    border-bottom: 1px solid ${({ theme }) => theme.componentExtensions.border.secondary};
`
